
import AdminNavbar from "../../../components/navbar/navbarAdmin";
import ViewTable from "./viewTable";
const AdminCodes = () => {
 
  return (    
    <div >
      <div style={{alignItems:"center",justifyContent:"center",display:"flex",marginTop:"30px"}}>
      <AdminNavbar/>
      </div>
      <div style={{alignItems:"center",justifyContent:"center",display:"flex",marginTop:"30px"}}>

      
           <ViewTable />
      </div>
           
      </div>
  )
}

export default AdminCodes